export const REPORT_TYPES = {
  SINGLE: "SINGLE",
  MULTI: "MULTI",
  DAILY: "DAILY",
  FOR_MONITORING: "FOR_MONITORING",
};

export const REPORT_EXPORT_TYPE = {
  PDF: "PDF",
  EXCEL: "EXCEL",
};
